import React, { useState } from 'react';
import axios from 'axios';

const AdminAccessPage = () => {
  const [query, setQuery] = useState('');
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionStatus, setActionStatus] = useState(null);

  const fetchBooking = async () => {
    if (!query.trim()) return;
    setLoading(true);
    setBooking(null);
    setActionStatus(null);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`/api/admin/bookings/${query}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBooking(res.data);
    } catch (err) {
      console.error(err);
      setBooking(null);
      setActionStatus({ type: 'error', message: 'Booking not found.' });
    } finally {
      setLoading(false);
    }
  };

  const triggerAccess = async (id) => {
    setActionStatus(null);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`/api/admin/trigger-access/${id}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setActionStatus({ type: 'success', message: res.data.message || 'Access triggered.' });
    } catch (err) {
      console.error(err);
      setActionStatus({ type: 'error', message: 'Failed to trigger access.' });
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-bold">Admin Manual Access</h1>

      <div className="flex gap-2">
        <input
          type="text"
          placeholder="Enter Booking ID or License Plate"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="border rounded p-2 w-full"
        />
        <button
          onClick={fetchBooking}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Search
        </button>
      </div>

      {loading && <p className="text-gray-500">Loading...</p>}

      {booking && (
        <div className="bg-white border rounded p-4 shadow">
          <h2 className="text-lg font-semibold mb-2">Booking #{booking.id}</h2>
          <p><strong>Plate:</strong> {booking.license_plate}</p>
          <p><strong>Space ID:</strong> {booking.space_id}</p>
          <p><strong>Time:</strong> {new Date(booking.start_time).toLocaleString()} → {new Date(booking.end_time).toLocaleString()}</p>
          <p><strong>Status:</strong> {booking.status}</p>
          <p><strong>Access:</strong> {booking.access_granted ? 'Granted' : 'Not Granted'}</p>

          <button
            className="mt-4 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
            onClick={() => triggerAccess(booking.id)}
          >
            Trigger Access
          </button>
        </div>
      )}

      {actionStatus && (
        <div className={`p-2 rounded text-sm ${actionStatus.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
          {actionStatus.message}
        </div>
      )}
    </div>
  );
};

export default AdminAccessPage;
